import React from 'react';
import PropTypes from 'prop-types';

const Check = ({
	fill = '#80cecf',
	...props
}) => (
	<svg width="62" height="50" viewBox="0 0 62 50" fill={fill} {...props}>
		<polygon points="20.67 50 0 28.76 7.31 21.24 20.67 34.97 54.69 0 62 7.51 20.67 50" />
	</svg>
);

Check.propTypes = {
	fill: PropTypes.string,
};

export default Check;
